<div class="sale-resume">
    <!-- =====================================================
         HEADER
    ====================================================== -->
    <header class="sale-resume__header">
        <div class="sale-resume__header-content">
            <span class="sale-resume__eyebrow">
                NINA PASTELERÍA
            </span>
            <h2>
                Compra finalizada
            </h2>
        </div>
        <button type="button" class="sale-resume__close" mat-dialog-close aria-label="Cerrar">
            <mat-icon>
                close
            </mat-icon>
        </button>
    </header>
    <!-- =====================================================
         CONTENIDO
    ====================================================== -->
    <mat-dialog-content class="sale-resume__content">
        <div class="sale-resume__layout">
            <!-- =================================================
                 INFORMACIÓN
            ================================================== -->
            <section class="sale-resume__info">
                <!-- ÉXITO -->
                <div class="sale-resume__success">
                    <div class="sale-resume__success-icon">
                        <mat-icon>
                            check
                        </mat-icon>
                    </div>
                    <div>
                        <span class="sale-resume__success-label">
                            ¡LISTO!
                        </span>
                        <h1>
                            ¡Agradecemos tu compra!
                        </h1>
                        <p>
                            Tu pedido ha sido registrado correctamente.
                        </p>
                    </div>
                </div>
                <!-- FOLIO -->
                <div class="sale-resume__folio" *ngIf="saleData?.idVenta">
                    <span>
                        FOLIO DE TU PEDIDO
                    </span>
                    <strong>
                        #{{ saleData.idVenta }}
                    </strong>
                </div>
                <!-- PRODUCTOS -->
                <div class="sale-resume__section">
                    <div class="sale-resume__section-heading">
                        <span class="sale-resume__section-eyebrow">
                            TU PEDIDO
                        </span>
                        <h3>
                            Productos
                        </h3>
                    </div>
                    <div class="sale-resume__products">
                        <div class="sale-resume__product" *ngFor="let product of saleData.products">
                            <div class="sale-resume__product-icon">
                                <mat-icon>
                                    cake
                                </mat-icon>
                            </div>
                            <div class="sale-resume__product-info">
                                <strong>
                                    {{
                                    product?.productoAgrupador ||
                                    product?.nombre ||
                                    product?.descripcionProducto
                                    }}
                                </strong>
                                <span>
                                    Cantidad: {{ product.qty }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- ENTREGA -->
                <div class="sale-resume__delivery">
                    <div class="sale-resume__delivery-icon">
                        <mat-icon>
                            {{
                            saleData.shippeable
                            ? 'local_shipping'
                            : 'store'
                            }}
                        </mat-icon>
                    </div>
                    <div class="sale-resume__delivery-info">
                        <span class="sale-resume__delivery-label">
                            {{
                            saleData.shippeable
                            ? 'ENTREGA A DOMICILIO'
                            : 'RECOGER EN SUCURSAL'
                            }}
                        </span>
                        <ng-container *ngIf="saleData.shippeable == false">
                            <strong>
                                Puedes recoger tu pedido en:
                            </strong>
                            <span>
                                Sucursal {{ saleData.branch.nombre }}
                            </span>
                        </ng-container>
                        <ng-container *ngIf="saleData.shippeable == true">
                            <strong>
                                Tu pedido será entregado en breve.
                            </strong>
                            <span>
                                Te mantendremos informado sobre su entrega.
                            </span>
                        </ng-container>
                    </div>
                </div>
                <!-- ACCIONES -->
                <div class="sale-resume__actions">
                    <button type="button" class="sale-resume__button sale-resume__button--primary" (click)="okBtn()">
                        <mat-icon>
                            check
                        </mat-icon>
                        <span>
                            OK
                        </span>
                    </button>
                    <button type="button" class="sale-resume__button sale-resume__button--secondary"
                        (click)="goToFacturar()">
                        <mat-icon>
                            receipt_long
                        </mat-icon>
                        <span>
                            Facturar
                        </span>
                    </button>
                </div>
            </section>
        </div>
    </mat-dialog-content>
</div>